import axios from "axios";

export const SIGNUP = "SIGNUP";
export const LOGIN = "LOGIN";

export const LOGOUT = "LOGOUT";
export const HASSIGNED = "HASSIGNED";

export const login = (values) => {
  return async (dispatch) => {
    return axios
      .post("/login", values)
      .then((res) => {
        if(res.data["loggedIn"] !== 2){
          return {success: 0, err: res.data.message};
        }else{
          dispatch({ type: LOGIN, data: res.data });
          return {success: 1, nombre: res.data.nombre};
        }
      })
      .catch((err) => {
        throw new Error(err.message);
      });
  };
};

export const hasSigned = (values) => {
  return async (dispatch) => {
    return axios
      .get("/hasSigned", values)
      .then((res) => {
        if (res.data["loggedIn"] === 2) {
          dispatch({ type: HASSIGNED, data: res.data });
          return {success: 1, data: res.data};
        } else {
          return {success: 0, err: "No se puede acceder a la pagina sin iniciar sesión"};
        }
      })
      .catch((err) => {
        throw new Error(err.message);
      });
  };
};

export const logout = () => {
  return async (dispatch) => {
    return axios
      .post("/logout")
      .then((res) => {
        if (res.data.success === 1) {
          return {success: 1};
        } else {
          dispatch({ type: LOGOUT });
          return {success: 0, err: "No se pudo cerrar la sesion"};
        }
      })
      .catch((err) => {
        throw new Error(err.message);
      });
  };
};
